export default {
  group_name_placeholder: 'Definir nome do canal',
  group_purpose_placeholder: 'Definir finalidade do canal',
};
